/**
 * Tipos de validação e mensagens para Throughput
 */
export const VALIDATION_TYPES = {
  MISSING_ID: {
    type: 'missing_id',
    getMessage: (lineNumber) => `Linha ${lineNumber}: O campo 'ID' é obrigatório e não pode estar vazio.`
  },
  MISSING_TIPO: {
    type: 'missing_tipo',
    getMessage: (lineNumber, id) => `Linha ${lineNumber}: O campo 'Tipo de Item' é obrigatório e não pode estar vazio (ID: "${id || 'ID não informado'}").`
  },
  MISSING_CLOSED_DATE: {
    type: 'missing_closed_date',
    getMessage: (lineNumber, id) => `Linha ${lineNumber}: O campo 'Closed Date' é obrigatório e não pode estar vazio (ID: "${id || 'ID não informado'}").`
  },
  INVALID_CLOSED_DATE: {
    type: 'invalid_closed_date',
    getMessage: (lineNumber, date, id) => `Linha ${lineNumber}: 'Closed Date' "${date}" não é uma data válida (ID: "${id || 'ID não informado'}").`
  }
};
